import { env } from '../utils/environment'

export const useIsTradingEnabled = () => {
    return { isTradingEnabled: env.VITE_RIVER_ENV === 'omega' }
}
